<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'ContractShipperPage',

};
</script>

<style>

</style>
